<template>

    <div>
        <sc-field :label="label"></sc-field>
      <sc-select
        class="form-control"
        v-model="selectedOption"
        @input="onChange" >
        <option v-if="!this.fieldSchema.required || !this.fieldSchema.default" disabled value="">Escolha uma opção</option>
        <option v-for="(opt, key) in this.fieldSchema.options" :value="opt" >
          {{ key }}
        </option>
      </sc-select>
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from "vuex";
  import {
    ScSelect,
    ScField
  } from "@intelipost-js/secure-components";
  const { mapState, mapActions } = createNamespacedHelpers(
    "integrations/integrationsHome"
  );
  export default {
    data() {
      return {
        selectedOption:"",
        oldSelectedOption:[],
        label:"",
      }
    },
    props: {
      fieldSchema: {
        type: Object,
      }
    },
    computed: {
      ...mapState(["appConfigUpdated"]),
    },
    methods: {
      ...mapActions([
        "updateAppConfig",
      ]),
      onChange() {
        this.updateOptionFieldsInAppConfig()
        this.oldSelectedOption = this.selectedOption;
      },
      updateOptionFieldsInAppConfig() {
        const appConfig = {
          ...this.appConfigUpdated,
        };
        if (this.oldSelectedOption) {
          delete appConfig[this.oldSelectedOption];
        }
        appConfig[this.fieldSchema.name] = this.selectedOption
        this.updateAppConfig(appConfig);
      },
    },

    mounted() {
        this.label = this.fieldSchema.title;
        
        if (!this.label) 
            this.label = this.fieldSchema.name;

        this.label += this.fieldSchema.required ? ' (Obrigatório)' : ' (Opcional)';

        this.selectedOption = this.appConfigUpdated[this.fieldSchema.name];

        if (!this.selectedOption) {
            this.selectedOption = this.fieldSchema.default;
        }

        if (this.selectedOption) {
            this.onChange();
        }
    },

    components: {
      ScSelect,
      ScField
    }
    ,
  }
  </script>
  
  <style>
  </style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/OptionField.vue?6a51114e